import { Link, useParams } from 'react-router-dom'
import { Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SectionWrapper } from '../section-wrapper'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { TopItemsStatisticListWrapper } from './top-items-statistic-list-wrapper.component'
import { TopItemsStatisticListItem } from './top-items-statistic-list-item.component'
import { NoDataMsg } from '../no-data-msg.component'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { useAccountTopItems } from 'src/hooks'

import useStyles from './styles'
// import { TopItemsStatisticItemV2 } from './v2/TopItemsStatisticItemV2'

const TopItemsStatisticWrapper = () => {
  const [t] = useTranslation()
  const { accountId } = useParams()
  const { data: topItems, isSuccess } = useAccountTopItems()
  const classes = useStyles()

  const hasNoProductsViews = topItems?.topProductsViews.length === 0 && isSuccess
  const hasnNoImpactsLikes = topItems?.topImpactsLikes.length === 0 && isSuccess
  return (
    <Grid container className={classes.statisticsSectionWrapper} spacing={2.5}>
      <Grid item container mobile_m={12} tablet={6}>
        <SectionWrapper title={t('dashboard-viewed-products-title.v')}>
          <TopItemsStatisticListWrapper title={t('dashboard-viewed-products-title.v')}>
            {topItems?.topProductsViews.map((item, index) => (
              // <TopItemsStatisticItemV2
              //   countType={'views'}
              //   count={item.views}
              //   title={item.product.name}
              //   index={index}
              //   icon={item.product.image_medium ?? item.product.image}
              //   link={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.PRODUCTS, item.product.id)}
              //   key={item.product.id}
              // />
              <TopItemsStatisticListItem
                link={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.PRODUCTS, item.product.id)}
                key={item.product.id}
                index={index}
                title={item.product.name}
                icon={item.product.image_medium ?? item.product.image ?? item.product.image_small}
                countType="views"
                count={item.views}
                code={item.product.code}
              />
            ))}
            {hasNoProductsViews && <NoDataMsg message={t('product-not-found.v')} />}
          </TopItemsStatisticListWrapper>

          {!hasNoProductsViews && (
            <Button component={Link} to="products/views">
              <HelperWrapper t="dashboard-viewed-products-button" />
            </Button>
          )}
        </SectionWrapper>
      </Grid>
      <Grid item container mobile_m>
        <SectionWrapper title={t('dashboard-liked-impacts-title.v')}>
          <TopItemsStatisticListWrapper title={t('dashboard-liked-impacts-title.v')}>
            {topItems?.topImpactsLikes.map((item, index) => (
              // <TopItemsStatisticItemV2
              //   countType={'likes'}
              //   count={item.likes}
              //   title={item.impact.name}
              //   index={index}
              //   icon={item.impact.image}
              //   link={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.IMPACTS, item.impact.id)}
              //   key={item.impact.id}
              // />
              <TopItemsStatisticListItem
                key={item.impact.id}
                index={index}
                title={item.impact.name}
                icon={item.impact.image_medium ?? item.impact.image ?? item.impact.image_small}
                countType="likes"
                count={item.likes}
                link={joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.IMPACTS, item.impact.id)}
                code={item.impact.code}
              />
            ))}
            {hasnNoImpactsLikes && <NoDataMsg message={t('impact-not-found.v')} />}
          </TopItemsStatisticListWrapper>
          {!hasnNoImpactsLikes && (
            <Button component={Link} to="impacts/likes">
              <HelperWrapper t="dashboard-viewed-impacts-button" />
            </Button>
          )}
        </SectionWrapper>
      </Grid>
    </Grid>
  )
}
export { TopItemsStatisticWrapper }
